import React from 'react'
import Layout from "../components/layout/Calayout"
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const TaxPreparation = () => {
  return (
    <Layout>
    <div>CaTasks</div>
    <p>up cooming</p>
    <Button>
      <Link to="/Dashboard">go back</Link>
    </Button>
  </Layout>
  )
}

export default TaxPreparation